module.exports = __webpack_public_path__ + "img/case_10.d4c45599.png";